export default __webpack_public_path__ + "static/media/ivan.2d56d815.jpeg";